import { hydrateRoot } from 'react-dom/client'
import App from './App.jsx'
import { loadMetrika } from './analytics.js'

loadMetrika()
hydrateRoot(document.getElementById('root'), <App url={window.location.pathname} />)
